import React, {useState } from 'react'
import { storage } from '../../firebase';
import EpicMenu from '../../componentes/Menus/EpicMenu';
import RolDropdown from '../../componentes/RolDropdown'
import { Modal, Icon } from 'semantic-ui-react'
import FileList from './Lista'

const Documentos = () => {
    return (
      <div>
        <div className='header'>
          <EpicMenu />
          <div className='inline'>Documentos</div>
          <div className="addNew" ><ModalAgregar /></div>
        </div>
        <div className='body'>
          <FileList />
        </div>
        <div className="footer" >
          <div className="footer1" ></div>
          <div className="footer2" ></div>
			  </div>
      </div>
    );
  };
  const ModalAgregar = () => {
    const [open, setOpen] = useState(false);
    const handleFileUpload = () => {
      setOpen(false);
    };

    return (
      <Modal 
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={<button><Icon name='plus' />Agregar</button>}>
        <Modal.Header>
            <div>Nuevo Documento</div>
        </Modal.Header>
        <Modal.Content>
          <FileUpload setOpen={handleFileUpload} />
        </Modal.Content>
      </Modal>
    )
	}

const FileUpload = ({setOpen }) => {
    const [file, setFile] = useState(null);
    const [rol, setRol] = useState('user');
    const [progress, setProgress] = useState(0);
    
    const handleFileChange = (e) => {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    };
    const handleRolChange = (event, { value }) => {
      setRol(value);
    };
    const handleUpload = () => {
      if (file) {
        const uploadTask = storage.ref(`documentos/${rol}/${file.name}`).put(file);
  
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(progress);
          },
          (error) => {
            console.log(error);
          },
          () => {
            storage
              .ref(`documentos/${rol}`)
              .child(file.name)
              .getDownloadURL()
              .then((url) => {
                console.log('File uploaded successfully. URL:', url);
                // Do something with the file URL, such as saving it to a database
              });
          }
        );
        setOpen(false)
      }
    };
  
    return (
      <div>
        <div>Seleccione el Rol: 

        <RolDropdown 
					placeholder='Rol Empleados'
					value={rol} 
					onChange={handleRolChange} 
					all={1} 
				/>
        <input type="file" onChange={handleFileChange} />
        <button onClick={handleUpload}>Subir</button>
        </div>
        <progress value={progress} max="100" />
      </div>
    );
  };
  
  export default Documentos;